import { CoreButton } from "../../core/ui/button/button";
import { CoreInput } from "../../core/ui/input/input";
import { observer } from "mobx-react-lite";
import { TaskEditorStore } from "./task_editor_store";
import { TypesTasks } from "./task_model";

export const FieldError = observer(({ store, path }: { store: TaskEditorStore; path: string }) => {
  const messages = Object.entries(store.fieldErrors).filter(([key]) => key === path || key.startsWith(path + "."));
  return messages.length ? <div className="field-error" role="alert">{messages.map(([key, message]) => <div key={key}>{message}</div>)}</div> : null;
});
interface EditorProps { store: TaskEditorStore }
const AnswerRows = observer(({ store, choices = false }: EditorProps & { choices?: boolean }) => <>
  <p className="muted">{choices ? "Добавьте варианты, задайте порядок и отметьте правильные ответы." : "Добавьте все допустимые ответы. Каждый ответ — в отдельном поле."}</p>
  {store.answers.map((answer, index) => <div className="answer-row" key={index}>
    <div className="answer-fields">
      {choices && <label className="correct-answer"><input
        type={store.model.task.type === TypesTasks.oneOfSeveral ? "radio" : "checkbox"}
        name="correct-answer" checked={answer.isRight}
        onChange={event => store.markAnswer(index, event.target.checked)}
      /> Правильный {index + 1}</label>}
      <CoreInput native label={`${choices ? "Вариант" : "Ответ"} ${index + 1}`}
        value={answer.text} invalid={Object.keys(store.fieldErrors).some(key => key.startsWith(`task.answers.${index}`))}
        inputMode={store.model.task.type === TypesTasks.onlyNumber ? "decimal" : "text"}
        onChange={value => store.setAnswerText(index, value)} />
      <FieldError store={store} path={`task.answers.${index}`} />
    </div>
    <div className="row-actions">
      {choices && <>
        <CoreButton type="button" aria-label={`Вариант ${index + 1} вверх`} disabled={index === 0} onClick={() => store.moveAnswer(index, -1)}>↑</CoreButton>
        <CoreButton type="button" aria-label={`Вариант ${index + 1} вниз`} disabled={index === store.answers.length - 1} onClick={() => store.moveAnswer(index, 1)}>↓</CoreButton>
      </>}
      <CoreButton type="button" aria-label={`Удалить ответ ${index + 1}`} onClick={() => store.removeAnswer(index)}>Удалить</CoreButton>
    </div>
  </div>)}
  <CoreButton type="button" onClick={() => store.addAnswer()}>+ {choices ? "Добавить вариант" : "Добавить ответ"}</CoreButton>
  {store.fieldErrors["task.answers"] && <div role="alert" className="field-error">{store.fieldErrors["task.answers"]}</div>}
</>);
const TextAnswers = ({ store }: EditorProps) => <AnswerRows store={store} />;
const NumberAnswers = ({ store }: EditorProps) => <><p className="muted">Числа вводятся с точкой: 0, −3, 1.5. Пустое поле не считается нулём.</p><AnswerRows store={store} /></>;
const SingleAnswers = ({ store }: EditorProps) => <AnswerRows store={store} choices />;
const MultipleAnswers = ({ store }: EditorProps) => <AnswerRows store={store} choices />;
export const taskEditors = [
  { type: TypesTasks.onlyText, Component: TextAnswers },
  { type: TypesTasks.onlyNumber, Component: NumberAnswers },
  { type: TypesTasks.oneOfSeveral, Component: SingleAnswers },
  { type: TypesTasks.severalOSeveral, Component: MultipleAnswers },
];
export const TaskEditor = observer(({ store }: EditorProps) => {
  const editor = taskEditors.find(item => item.type === store.model.task.type);
  return editor ? <editor.Component store={store} /> : null;
});
